<script>
    import { SvelteTable } from "../../Common/index.svelte";

    import { getDisplayColumn } from "./customizeTableHelper.svelte";

    export let columns = [],
        rows = [],
        clickCellFunc = () => {},
        clickColFunc = () => {};

    export let tableConfig = { bgColor: () => {} };

    let tableRef;

    $: config = {
        showStickyLeftBlur: true,
        bgColor: "bg-white",
        ...tableConfig,
    };

    $: displayColumn = getDisplayColumn(columns, tableRef, config);
</script>

<div class="flex flex-1 w-full" bind:this={tableRef}>
    <SvelteTable
        columns={displayColumn}
        {rows}
        classNameCell=""
        classNameRow="bg-white border-y-2 hover:bg-[#f3f3f3] h-full"
        classNameThead="bg-white sticky top-0 h-10 z-[30] text-[#6F726C]"
        {clickCellFunc}
        {clickColFunc}
        customRowClass={(v) => tableConfig.bgColor(v)}
    />
</div>
